/* eslint-disable react-hooks/exhaustive-deps */
import classnames from "classnames";
import parse from "html-react-parser";
import React, { useCallback, useEffect, useState } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from "react-accessible-accordion";
import { useDropzone } from "react-dropzone";
import { useForm } from "react-hook-form";
import { RxOpenInNewWindow } from "react-icons/rx";
import { LazyLoadImage } from "react-lazy-load-image-component";
import ReactQuill from "react-quill";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  Card,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  Spinner,
  UncontrolledDropdown,
} from "reactstrap";
import SimpleBar from "simplebar-react";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from "uuid";
import PlaceholderImg from "../../assets/placeholder-img.png";
import SEOInputs from "../../components/common/SEOInputs";
import {
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  DataTableBody,
  DataTableHead,
  DataTableItem,
  DataTableRow,
  Icon,
  PaginationComponent,
  RSelect,
  Row,
} from "../../components/Component";
import ErrorComponent from "../../components/error/ErrorComponent";
import { QuillComponent } from "../../components/partials/rich-editor/QuillComponent";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { deleteFile, uploadFile } from "../../redux/Apislices/awsSlice";
import { getcityByProvince } from "../../redux/Apislices/citySlice";
import { getCountry } from "../../redux/Apislices/countrySlice";
import {
  addProvince,
  deleteProvince,
  getAllProvince,
  getprovince,
  updateProvince,
} from "../../redux/Apislices/provinceSlice";
import { convertToSlug, generateFAQSchema } from "../../utils/Utils";
import JoditPreview from "../components/forms/rich-editor/JoditPreview";
import TinyMceEditor from "../components/forms/rich-editor/TinyMceEditor";
import styles from "./location.module.scss";

const Province = () => {
  const dispatch = useDispatch();
  const {
    provinces: { loading, success, data, error, total },
    allProvinces,
    countries,
    cities,
    permission,
    profile,
  } = useSelector((state) => ({
    provinces: state?.province?.provinces,
    allProvinces: state?.province?.allProvinces,
    countries: state?.country?.countries,
    cities: state?.city?.cityByProvince,
    permission: state?.auth?.profile?.permissions?.province,
    profile: state?.auth?.profile,
  }));
  const [sm, updateSm] = useState(false);

  const [formData, setFormData] = useState({ name: "", shortSymbol: "", slug: "", country: "", associateCost: "" });
  let { name, shortSymbol, slug, country, associateCost } = formData;

  const [bannerTitle, setBannerTitle] = useState("");
  const [bannerImg, setBannerImg] = useState("");
  const [imageData, setImageData] = useState(null);
  const [deleteImg, setDeleteImg] = useState(null);
  const [trigger, setTrigger] = useState(false);

  const [city, setCity] = useState(null);
  const [topCities, setTopCities] = useState([]);

  const [detailsTitle, setDetailsTitle] = useState("");
  const [detailsContent, setDetailsContent] = useState("");

  const [h2Title, setH2Title] = useState("");
  const [h2Content, setH2Content] = useState("");

  const [gridTitle, setGridTitle] = useState("");

  const [faqTitle, setFaqTitle] = useState("");
  const [faqContent, setFaqContent] = useState("");
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [faqEditIndex, setFaqEditIndex] = useState(null);
  const [faq, setFaq] = useState([]);

  const [faqsQuestion, setFaqsQuestion] = useState("");
  const [faqsAnswer, setFaqsAnswer] = useState("");
  const [faqsEditIndex, setFaqsEditIndex] = useState(null);
  const [faqs, setFaqs] = useState([]);

  const [seoTitle, setSeoTitle] = useState("");
  const [seoDescription, setSeoDescription] = useState("");
  const [near, setNear] = useState("");
  const [nearby, setNearby] = useState([]);

  const [faqSchema, setFaqSchema] = useState("");

  const [searchLabel, setSearchLabel] = useState("");
  const [searchUrl, setSearchUrl] = useState("");
  const [popularSearch, setPopularSearch] = useState([]);

  const [searchOpen, setSearchOpen] = useState(false);
  const [editData, setEditData] = useState({ label: "", url: "", editId: "" });

  const [onSearchText, setSearchText] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(25);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const [sort, setSort] = useState("");

  const [view, setView] = useState({
    edit: false,
    add: false,
    details: null,
  });
  const [editId, setEditedId] = useState(null);

  const { errors, register, handleSubmit } = useForm();

  const onInputChange = (e) => {
    if (e.target.name === "name") {
      setFormData({ ...formData, [e.target.name]: e.target.value, slug: convertToSlug(e.target.value) });
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  // onChange function for searching name
  const onFilterChange = (e) => {
    setSearchText(e.target.value);
  };

  // function to close the form modal
  const onFormCancel = () => {
    setView({ edit: false, add: false });
    resetForm();
  };

  // function to reset the form
  const resetForm = () => {
    setFormData({ name: "", shortSymbol: "", slug: "", country: "" });
    setBannerTitle("");
    setBannerImg("");
    setDetailsTitle("");
    setDetailsContent("");
    setFaqTitle("");
    setQuestion("");
    setAnswer("");
    setFaq([]);
    setTopCities([]);
    setSeoTitle("");
    setSeoDescription("");
    setNearby([]);
    setSearchLabel("");
    setSearchUrl("");
    setPopularSearch(null);
    setImageData(null);
    setDeleteImg(null);
    setTrigger(false);
    setFaqSchema("");
    setEditData({ label: "", url: "", editId: "" });
  };

  // toggle function to view product details
  const toggle = (type) => {
    setView({
      edit: type === "edit" ? true : false,
      add: type === "add" ? true : false,
      details: type === "details" ? true : false,
    });
  };

  // category change
  const onCategoryChange = (value) => {
    setFormData({ ...formData, country: value });
  };

  // function to submit the form
  const onFormSubmit = (e) => {
    let data = {
      name,
      slug,
      shortSymbol,
      country: country?.value,

      details: { title: detailsTitle, content: detailsContent },

      h2details: { title: h2Title, content: h2Content },

      gridTitle,

      accordian: { title: faqTitle, description: faqContent, content: faq },

      popularSearch: popularSearch?.map((li) => {
        let a = li;
        delete a.editId;
        return a;
      }),

      faq: { title: faqTitle, content: faq },

      nearby: nearby?.map((li) => li.value) || [],

      metadata: { title: seoTitle, description: seoDescription },
      faqSchema: faqSchema,
    };

    if (!country || (typeof country === "object" && country?.value === "")) return toast.error("Country is required");

    dispatch(
      addProvince(
        data,
        (res) => {
          onFormCancel();
          dispatch(getprovince({ page: currentPage, limit: itemPerPage, search: onSearchText, sort }));
          toast.success(res?.message);
          setEditedId(null);
          resetForm();
          setView({ edit: false, add: false, details: false });
        },
        (res) => {
          toast.error(res?.message);
        }
      )
    );
  };

  const onEditSubmit = () => {
    let data = {
      name,
      slug,
      shortSymbol,
      country: country?.value,

      details: { title: detailsTitle, content: detailsContent },

      h2details: { title: h2Title, content: h2Content },

      gridTitle,

      accordian: { title: faqTitle, description: faqContent, content: faq },

      popularSearch: popularSearch?.map((li) => {
        let a = li;
        delete a.editId;
        return a;
      }),

      faqs: faqs?.length ? faqs : [],

      nearby: nearby?.map((li) => li.value) || [],

      metadata: { title: seoTitle, description: seoDescription },
      faqSchema: faqSchema,
    };

    if (!country || (typeof country === "object" && country?.value === "")) return toast.error("Country is required");

    dispatch(
      updateProvince(
        editId,
        data,
        (res) => {
          onFormCancel();
          dispatch(getprovince({ page: currentPage, limit: itemPerPage, search: onSearchText, sort }));
          toast.success(res?.message);
          setEditedId(null);
          resetForm();
          setView({ edit: false, add: false, details: false });
        },
        (res) => {
          toast.error(res?.message);
        }
      )
    );
  };

  // function that loads the want to editted data
  const onEditClick = (id) => {
    data.forEach((item) => {
      if (item._id === id) {
        console.log("item:======> ", item);
        setFormData({
          name: item.name,
          shortSymbol: item.shortSymbol,
          slug: item.slug,
          country: { label: item.country?.name, value: item.country?._id },
          associateCost: item.associateCost,
        });

        setDetailsTitle(item.details?.title);
        setDetailsContent(item.details?.content);

        setH2Title(item.h2details?.title);
        setH2Content(item.h2details?.content);

        setGridTitle(item.gridTitle);

        setFaqTitle(item.accordian?.title);
        setFaqContent(item.accordian?.description);
        setFaq(item.accordian?.content ? item.accordian?.content : []);

        setFaqs(item.faqs?.length ? item.faqs : []);

        setTopCities(item.topCities?.length ? item.topCities?.map((li) => ({ label: li.name, value: li._id })) : []);
        setSeoTitle(item.metadata?.title);
        setSeoDescription(item.metadata?.description);
        setNearby(item.nearby?.length ? item.nearby?.map((li) => ({ label: li.name, value: li._id })) : []);
        setPopularSearch(item.popularSearch?.map((li) => ({ ...li, editId: li._id })));
        setFaqSchema(item.faqSchema);
      }
    });
    setEditedId(id);
    setView({ add: false, edit: true, details: false });
  };

  const onDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Delete",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          deleteProvince(
            id,
            (res) => {
              dispatch(getprovince({ page: currentPage, limit: itemPerPage, search: onSearchText, sort }));
              toast.success(res?.message);
            },
            (res) => {
              toast.error(res?.message);
            }
          )
        );
      }
    });
  };

  const handleUpload = (file, CB, EB) => {
    dispatch(
      uploadFile(
        file,
        (res) => {
          CB(res);
        },
        (res) => {
          toast.error(res?.message);
          EB(res);
        }
      )
    );
  };

  const onDrop = useCallback(
    (acceptedFiles, fileRejections) => {
      fileRejections.forEach((file) => {
        file.errors.forEach((err) => {
          if (err.code === "file-too-large") {
            toast.error("File is larger than 20 MB");
          }
          if (err.code === "file-invalid-type") {
            toast.error(err.message);
          }
        });
      });

      const newImages = acceptedFiles.map((file, index) => {
        let fileName = name ? convertToSlug(name) : "city";
        const newName = `${fileName}-${uuidv4()?.slice(0, 8)}.${file.name.split(".").pop()}`;
        setBannerImg(URL.createObjectURL(file));
        return new File([file], newName, { type: file.type });
      });
      const formData = new FormData();
      newImages.forEach((file) => {
        formData.append("file", file);
      });
      formData.append("path", "admin/province");
      // formData.append("fit", "cover");
      formData.append("width", 1500);
      formData.append("height", 396);
      setImageData(formData);
      // handleUpload(formData);
    },
    [name]
  );

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    maxFiles: 1,
    accept: {
      "image/jpg": [".jpg"],
      "image/jpeg": [".jpeg"],
      "image/png": [".png"],
    },
    maxSize: 20971520,
  });

  const handleDelete = (path) => {
    if (path?.includes("blob")) {
      return setBannerImg("");
    } else {
      setDeleteImg(path);
      setBannerImg("");
    }
  };

  const deleteAwsImage = (path, cb, eb) => {
    dispatch(
      deleteFile(
        { path },
        (res) => {
          cb(res);
        },
        (res) => {
          eb(res);
        }
      )
    );
  };

  useEffect(() => {
    if (trigger) setTrigger(false);
  }, [trigger]);

  useEffect(() => {
    dispatch(getcityByProvince(editId));
  }, [editId]);

  useEffect(() => {
    dispatch(getCountry());
    dispatch(getAllProvince());
  }, []);

  useEffect(() => {
    const timer = setTimeout(
      () => {
        dispatch(getprovince({ page: currentPage, limit: itemPerPage, search: onSearchText, sort }));
      },
      onSearchText ? 800 : 100
    );

    return () => clearTimeout(timer);
  }, [currentPage, dispatch, itemPerPage, onSearchText, sort]);

  useEffect(() => {
    if (faqs?.length) setFaqSchema(generateFAQSchema(faqs));
  }, [faqs]);

  return (
    <React.Fragment>
      <Head title="Province"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                Province
              </BlockTitle>
              <BlockDes className="text-soft">
                <p>
                  List of the total {total?.total} {total?.total === 1 ? "province" : "provinces"}
                </p>
              </BlockDes>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <Button
                  className={`btn-icon btn-trigger toggle-expand mr-n1 ${sm ? "active" : ""}`}
                  onClick={() => updateSm(!sm)}
                >
                  <Icon name="more-v" />
                </Button>
                <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                  <ul className="nk-block-tools g-3">
                    <li>
                      <div className="form-control-wrap">
                        <div className="form-icon form-icon-right">
                          <Icon name="search"></Icon>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          id="default-04"
                          placeholder="Search by name..."
                          onChange={(e) => onFilterChange(e)}
                        />
                      </div>
                    </li>
                    <li className="nk-block-tools-opt">
                      <Button
                        color="primary"
                        onClick={() => {
                          toggle("add");
                        }}
                        disabled={permission && !permission?.add}
                      >
                        <Icon name="plus" />
                        <span>Add Province</span>
                      </Button>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <Card className="card-bordered">
            <div className="card-inner-group">
              {loading ? (
                <div
                  style={{
                    height: "200px",
                    width: "100%",
                    display: "grid",
                    placeItems: "center",
                  }}
                >
                  <Spinner type="grow" color="dark" />
                </div>
              ) : (
                <div className="card-inner p-0">
                  <DataTableBody>
                    <DataTableHead>
                      <DataTableRow>
                        <span
                          onClick={() => {
                            setSort(sort === "asc" ? "desc" : sort === "desc" ? "asc" : "desc");
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          Name
                          <Icon name={sort === "asc" ? "sort-up-fill" : sort === "desc" ? "sort-down-fill" : "sort"} />
                        </span>
                      </DataTableRow>
                      <DataTableRow>
                        <span>Short Symbol</span>
                      </DataTableRow>
                      <DataTableRow>
                        <span>Slug</span>
                      </DataTableRow>
                      <DataTableRow>
                        <span
                          onClick={() => {
                            setSort(
                              sort === "country-asc"
                                ? "country-desc"
                                : sort === "country-desc"
                                ? "country-asc"
                                : "country-desc"
                            );
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          Country
                          <Icon
                            name={
                              sort === "country-asc"
                                ? "sort-up-fill"
                                : sort === "country-desc"
                                ? "sort-down-fill"
                                : "sort"
                            }
                          />
                        </span>
                      </DataTableRow>
                      <DataTableRow className="nk-tb-col-tools text-right">
                        <UncontrolledDropdown>
                          <DropdownToggle color="tranparent" className="btn btn-trigger btn-icon dropdown-toggle">
                            <Icon name="setting"></Icon>
                          </DropdownToggle>
                          <DropdownMenu right className="dropdown-menu-xs">
                            <ul className="link-check">
                              <li>
                                <span>Show</span>
                              </li>
                              <li className={itemPerPage === 25 ? "active" : ""}>
                                <DropdownItem
                                  tag="a"
                                  href="#dropdownitem"
                                  onClick={(ev) => {
                                    ev.preventDefault();
                                    setItemPerPage(25);
                                  }}
                                >
                                  25
                                </DropdownItem>
                              </li>
                              <li className={itemPerPage === 50 ? "active" : ""}>
                                <DropdownItem
                                  tag="a"
                                  href="#dropdownitem"
                                  onClick={(ev) => {
                                    ev.preventDefault();
                                    setItemPerPage(50);
                                  }}
                                >
                                  50
                                </DropdownItem>
                              </li>
                              <li className={itemPerPage === 100 ? "active" : ""}>
                                <DropdownItem
                                  tag="a"
                                  href="#dropdownitem"
                                  onClick={(ev) => {
                                    ev.preventDefault();
                                    setItemPerPage(100);
                                  }}
                                >
                                  100
                                </DropdownItem>
                              </li>
                            </ul>
                            <ul className="link-check">
                              <li>
                                <span>Order</span>
                              </li>
                              <li className={sort === "asc" ? "active" : ""}>
                                <DropdownItem
                                  tag="a"
                                  href="#dropdownitem"
                                  onClick={(ev) => {
                                    ev.preventDefault();
                                    setSort("asc");
                                  }}
                                >
                                  ASC
                                </DropdownItem>
                              </li>
                              <li className={sort === "desc" ? "active" : ""}>
                                <DropdownItem
                                  tag="a"
                                  href="#dropdownitem"
                                  onClick={(ev) => {
                                    ev.preventDefault();
                                    setSort("desc");
                                  }}
                                >
                                  DESC
                                </DropdownItem>
                              </li>
                            </ul>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </DataTableRow>
                    </DataTableHead>
                    {success && data?.length ? (
                      data?.map((item) => {
                        return (
                          <DataTableItem key={item?._id}>
                            <DataTableRow>
                              <div className="tb-product">
                                <div className="title">
                                  <span
                                    onClick={() => {
                                      // onEditClick(item._id);
                                      // toggle("details");
                                    }}
                                    // style={{ cursor: "pointer" }}
                                  >
                                    {item?.name}
                                  </span>
                                  <a
                                    href={`${process.env.REACT_APP_USER_WEB_URL}province/${item?.slug}`}
                                    target="_blank"
                                    style={{ marginLeft: "5px", cursor: "pointer" }}
                                    rel="noreferrer"
                                  >
                                    <RxOpenInNewWindow style={{ color: "#00aeff", fontSize: "18px" }} />
                                  </a>
                                </div>
                              </div>
                            </DataTableRow>
                            <DataTableRow>
                              <span className="tb-sub">{item?.shortSymbol}</span>
                            </DataTableRow>
                            <DataTableRow>
                              <span className="tb-sub">{item?.slug}</span>
                            </DataTableRow>
                            <DataTableRow>
                              <span className="tb-sub">{item?.country?.name}</span>
                            </DataTableRow>
                            <DataTableRow className="nk-tb-col-tools">
                              <ul className="nk-tb-actions gx-1 my-n1">
                                <li className="mr-n1">
                                  <UncontrolledDropdown>
                                    <DropdownToggle
                                      tag="a"
                                      href="#more"
                                      onClick={(ev) => ev.preventDefault()}
                                      className="dropdown-toggle btn btn-icon btn-trigger"
                                    >
                                      <Icon name="more-h"></Icon>
                                    </DropdownToggle>
                                    <DropdownMenu right>
                                      <ul className="link-list-opt no-bdr">
                                        {/* <li>
                                          <DropdownItem
                                            tag="a"
                                            href="#view"
                                            onClick={(ev) => {
                                              ev.preventDefault();
                                              onEditClick(item._id);
                                              toggle("details");
                                            }}
                                          >
                                            <Icon name="file-text"></Icon>
                                            <span>View Details</span>
                                          </DropdownItem>
                                        </li> */}
                                        <li>
                                          <DropdownItem
                                            tag="a"
                                            href="#edit"
                                            onClick={(ev) => {
                                              ev.preventDefault();
                                              onEditClick(item._id);
                                              toggle("edit");
                                            }}
                                            disabled={permission && !permission?.edit}
                                          >
                                            <Icon name="edit"></Icon>
                                            <span>Edit</span>
                                          </DropdownItem>
                                        </li>
                                        <li>
                                          <DropdownItem
                                            tag="a"
                                            href="#remove"
                                            onClick={(ev) => {
                                              ev.preventDefault();
                                              onDelete(item._id);
                                            }}
                                            disabled={permission && !permission?.delete}
                                          >
                                            <Icon name="trash"></Icon>
                                            <span>Delete</span>
                                          </DropdownItem>
                                        </li>
                                      </ul>
                                    </DropdownMenu>
                                  </UncontrolledDropdown>
                                </li>
                              </ul>
                            </DataTableRow>
                          </DataTableItem>
                        );
                      })
                    ) : success && !data?.length ? (
                      <div
                        className="text-center"
                        style={{
                          padding: "20px",
                          fontSize: "1rem",
                          fontWeight: "600",
                        }}
                      >
                        <span className="text-silent">No Provinces found</span>
                      </div>
                    ) : error ? (
                      <ErrorComponent error={error} />
                    ) : null}
                  </DataTableBody>
                  <div className="card-inner">
                    {data?.length ? (
                      <PaginationComponent
                        itemPerPage={total?.items_per_page || 25}
                        totalItems={total?.total}
                        paginate={paginate}
                        currentPage={currentPage || 1}
                      />
                    ) : null}
                  </div>
                </div>
              )}
            </div>
          </Card>
        </Block>
      </Content>

      <Modal
        isOpen={view.add || view.edit}
        toggle={() => {
          onFormCancel();
          if (view.edit) resetForm();
        }}
        className="modal-dialog-centered"
        size="lg"
      >
        <ModalBody>
          <a href="#cancel" className="close">
            <Icon
              name="cross-sm"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
            ></Icon>
          </a>

          <div className="p-2">
            <h5 className="title">{view.edit ? "Edit Province" : "Add Province"}</h5>
            <div className="mt-4">
              <form onSubmit={handleSubmit(view.edit ? onEditSubmit : onFormSubmit)}>
                <Row className="g-3">
                  {/* Name */}
                  <Col md="6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="product-title">
                        Name
                      </label>
                      <div className="form-control-wrap">
                        <input
                          type="text"
                          className="form-control"
                          name="name"
                          value={name}
                          onChange={(e) => onInputChange(e)}
                          ref={register({
                            required: "This field is required",
                          })}
                        />
                        {errors.name && <span className="invalid">{errors.name.message}</span>}
                      </div>
                    </div>
                  </Col>

                  {/* Slug */}
                  <Col md="6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="sale-price">
                        Slug
                      </label>
                      <div className="form-control-wrap">
                        <input
                          type="text"
                          className="form-control"
                          name="slug"
                          value={slug}
                          onChange={(e) => onInputChange(e)}
                          ref={register({ required: "This is required" })}
                        />
                        {errors.slug && <span className="invalid">{errors.slug.message}</span>}
                      </div>
                    </div>
                  </Col>

                  {/* Short Symbol */}
                  <Col md="6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="regular-price">
                        Short Symbol
                      </label>
                      <div className="form-control-wrap">
                        <input
                          type="text"
                          name="shortSymbol"
                          value={shortSymbol}
                          ref={register({ required: "This is required" })}
                          onChange={(e) => onInputChange(e)}
                          className="form-control"
                        />
                        {errors.shortSymbol && <span className="invalid">{errors.shortSymbol.message}</span>}
                      </div>
                    </div>
                  </Col>

                  {/* Country */}
                  <Col md="6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="regular-price">
                        Country
                      </label>
                      <div className="form-control-wrap">
                        <RSelect
                          name="country"
                          value={country}
                          options={
                            countries?.data?.length
                              ? countries?.data?.map((li) => ({
                                  label: li.name,
                                  value: li._id,
                                }))
                              : {
                                  label: "No country found",
                                  value: "",
                                }
                          }
                          isLoading={countries?.loading}
                          placeholder="Search & select a country..."
                          onChange={onCategoryChange}
                          ref={register({ required: "This is required" })}
                        />
                        {errors.category && <span className="invalid">{errors.category.message}</span>}
                      </div>
                    </div>
                  </Col>

                  <Col md="12">
                    <Accordion className={styles.a} allowZeroExpanded>
                      {/* Title & Summary (H1) */}
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>Title & Summary (H1)</AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <div className="form-group">
                            <Row className={"g-3"}>
                              <Col md="12">
                                <label className="form-label" htmlFor="regular-price">
                                  Title
                                </label>
                                <div className="form-control-wrap">
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={detailsTitle}
                                    name="detailsTitle"
                                    onChange={(e) => setDetailsTitle(e.target.value)}
                                  />
                                </div>
                              </Col>

                              <Col md="12">
                                <label className="form-label" htmlFor="regular-price">
                                  Summary
                                </label>
                                <div className="form-control-wrap">
                                  {/* <JoditPreview
                              initialValue={detailsContent}
                              getValue={setDetailsContent}
                              placeholder={"Enter the details"}
                            />{" "} */}
                                  <TinyMceEditor
                                    value={detailsContent}
                                    getValue={setDetailsContent}
                                    placeholder={"Enter the details"}
                                  />
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </AccordionItemPanel>
                      </AccordionItem>

                      {/* Title & Summary (H2) */}
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>Title & Summary (H2)</AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <div className="form-group">
                            <Row className={"g-3"}>
                              <Col md="12">
                                <label className="form-label" htmlFor="regular-price">
                                  Title
                                </label>
                                <div className="form-control-wrap">
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={h2Title}
                                    name="h2Title"
                                    onChange={(e) => setH2Title(e.target.value)}
                                  />
                                </div>
                              </Col>

                              <Col md="12">
                                <label className="form-label" htmlFor="regular-price">
                                  Summary
                                </label>
                                <div className="form-control-wrap">
                                  {/* <JoditPreview
                              initialValue={detailsContent}
                              getValue={setDetailsContent}
                              placeholder={"Enter the details"}
                            />{" "} */}
                                  <TinyMceEditor
                                    value={h2Content}
                                    getValue={setH2Content}
                                    placeholder={"Enter the details"}
                                  />
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </AccordionItemPanel>
                      </AccordionItem>

                      {/* Grid Title (H2) */}
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>Grid Title (H2)</AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <div className="form-group">
                            <Row className={"g-3"}>
                              <Col md="12">
                                <label className="form-label" htmlFor="regular-price">
                                  Title
                                </label>
                                <div className="form-control-wrap">
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={gridTitle}
                                    name="gridTitle"
                                    onChange={(e) => setGridTitle(e.target.value)}
                                  />
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </AccordionItemPanel>
                      </AccordionItem>

                      {/* Accordion */}
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>Accordion</AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <div className="form-group">
                            <Row className={"g-3"}>
                              <Col md="12">
                                <label className="form-label" htmlFor="regular-price">
                                  Title
                                </label>
                                <div className="form-control-wrap">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="question"
                                    value={question}
                                    onChange={(e) => setQuestion(e.target.value)}
                                  />
                                </div>
                              </Col>
                              <Col md="12">
                                <label className="form-label" htmlFor="regular-price">
                                  Content
                                </label>
                                <div className="form-control-wrap">
                                  <TinyMceEditor
                                    value={answer}
                                    getValue={setAnswer}
                                    placeholder={"Enter the details"}
                                  />
                                </div>
                              </Col>
                              <Col md="12">
                                {faqEditIndex !== null ? (
                                  <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
                                    <Button
                                      color="primary"
                                      onClick={() => {
                                        if (!question || !answer)
                                          return toast.error("Title and content both are required");
                                        let newFaq = [...faq];
                                        let data = { question, answer };
                                        newFaq?.splice(faqEditIndex, 0, data);
                                        setFaq(newFaq);
                                        setQuestion("");
                                        setAnswer("");
                                        setFaqEditIndex(null);
                                      }}
                                      type="button"
                                    >
                                      <span>Update</span>
                                    </Button>
                                    <Button
                                      color="primary"
                                      onClick={() => {
                                        let newFaq = [...faq];
                                        let data = { question, answer };
                                        newFaq?.splice(faqEditIndex, 0, data);
                                        setFaq(newFaq);
                                        setQuestion("");
                                        setAnswer("");
                                        setFaqEditIndex(null);
                                      }}
                                      type="button"
                                    >
                                      <span>Cancel</span>
                                    </Button>
                                  </div>
                                ) : (
                                  <Button
                                    color="primary"
                                    onClick={() => {
                                      // console.log("question: ", question);
                                      // console.log("answer: ", answer);
                                      if (!question || !answer)
                                        return toast.error("Title and content both are required");
                                      setFaq([...faq, { question, answer }]);
                                      setQuestion("");
                                      setAnswer("");
                                    }}
                                    type="button"
                                  >
                                    <span>Add</span>
                                  </Button>
                                )}
                              </Col>
                            </Row>

                            {faq?.length ? (
                              <Accordion className={styles.a} allowZeroExpanded preExpanded={[1]}>
                                {faq?.map((li, i) => {
                                  return (
                                    <AccordionItem key={i} uuid={i + 1}>
                                      <AccordionItemHeading>
                                        <AccordionItemButton>
                                          <div>
                                            <div>{parse(li?.question || "")}</div>
                                            <div className={styles.CTASection}>
                                              <div
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  setQuestion(li?.question);
                                                  setAnswer(li?.answer);
                                                  setFaqEditIndex(i);
                                                  setFaq(faq.filter((item, index) => index !== i));
                                                }}
                                                className={styles.edit}
                                              >
                                                <Icon name="edit" />
                                              </div>
                                              <div
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  setFaq(faq.filter((item, index) => index !== i));
                                                }}
                                                className={styles.close}
                                              >
                                                <Icon name="cross" />
                                              </div>
                                            </div>
                                          </div>
                                        </AccordionItemButton>
                                      </AccordionItemHeading>
                                      <AccordionItemPanel>
                                        <div className="answerContent">{parse(li?.answer || "")}</div>
                                      </AccordionItemPanel>
                                    </AccordionItem>
                                  );
                                })}
                              </Accordion>
                            ) : null}
                          </div>
                        </AccordionItemPanel>
                      </AccordionItem>

                      {/* Frequently Asked Questions */}
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>Frequently Asked Questions</AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <div className="form-group">
                            <Row className={"g-3"}>
                              <Col md="12">
                                <label className="form-label" htmlFor="regular-price">
                                  Question
                                </label>
                                <div className="form-control-wrap">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="faqsQuestion"
                                    value={faqsQuestion}
                                    onChange={(e) => setFaqsQuestion(e.target.value)}
                                  />
                                </div>
                              </Col>
                              <Col md="12">
                                <label className="form-label" htmlFor="regular-price">
                                  Answer
                                </label>
                                <div className="form-control-wrap">
                                  <TinyMceEditor
                                    value={faqsAnswer}
                                    getValue={setFaqsAnswer}
                                    placeholder={"Enter the Answer"}
                                  />
                                </div>
                              </Col>
                              <Col md="12">
                                {faqsEditIndex !== null ? (
                                  <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
                                    <Button
                                      color="primary"
                                      onClick={() => {
                                        if (!faqsQuestion || !faqsAnswer)
                                          return toast.error("Question and Answer both are required");
                                        let newFaq = [...faqs];
                                        let data = { question: faqsQuestion, answer: faqsAnswer };
                                        newFaq?.splice(faqsEditIndex, 0, data);
                                        setFaqs(newFaq);
                                        setFaqsQuestion("");
                                        setFaqsAnswer("");
                                        setFaqsEditIndex(null);
                                      }}
                                      type="button"
                                    >
                                      <span>Update</span>
                                    </Button>
                                    <Button
                                      color="primary"
                                      onClick={() => {
                                        let newFaq = [...faqs];
                                        let data = { question: faqsQuestion, answer: faqsAnswer };
                                        newFaq?.splice(faqsEditIndex, 0, data);
                                        setFaqs(newFaq);
                                        setFaqsQuestion("");
                                        setFaqsAnswer("");
                                        setFaqsEditIndex(null);
                                      }}
                                      type="button"
                                    >
                                      <span>Cancel</span>
                                    </Button>
                                  </div>
                                ) : (
                                  <Button
                                    color="primary"
                                    onClick={() => {
                                      if (!faqsQuestion || !faqsAnswer)
                                        return toast.error("Question and Answer both are required");
                                      setFaqs([...faqs, { question: faqsQuestion, answer: faqsAnswer }]);
                                      setFaqsQuestion("");
                                      setFaqsAnswer("");
                                    }}
                                    type="button"
                                  >
                                    <span>Add</span>
                                  </Button>
                                )}
                              </Col>
                            </Row>

                            {faqs?.length ? (
                              <Accordion className={styles.a} preExpanded={[1]} allowZeroExpanded>
                                {faqs?.map((li, i) => {
                                  return (
                                    <AccordionItem key={i} uuid={i + 1}>
                                      <AccordionItemHeading>
                                        <AccordionItemButton>
                                          <div>
                                            <div>{parse(li?.question || "")}</div>
                                            <div className={styles.CTASection}>
                                              <div
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  setFaqsQuestion(li?.question);
                                                  setFaqsAnswer(li?.answer);
                                                  setFaqsEditIndex(i);
                                                  setFaqs(faqs.filter((item, index) => index !== i));
                                                }}
                                                className={styles.edit}
                                              >
                                                <Icon name="edit" />
                                              </div>
                                              <div
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  setFaqs(faqs.filter((item, index) => index !== i));
                                                }}
                                                className={styles.close}
                                              >
                                                <Icon name="cross" />
                                              </div>
                                            </div>
                                          </div>
                                        </AccordionItemButton>
                                      </AccordionItemHeading>
                                      <AccordionItemPanel>
                                        <div className="answerContent">{parse(li?.answer || "")}</div>
                                      </AccordionItemPanel>
                                    </AccordionItem>
                                  );
                                })}
                              </Accordion>
                            ) : null}
                          </div>
                        </AccordionItemPanel>
                      </AccordionItem>

                      {/* SEO Content */}
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>SEO Content</AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <SEOInputs
                            titleValue={seoTitle}
                            titleChange={(e) => setSeoTitle(e.target.value)}
                            descriptionValue={seoDescription}
                            descriptionChange={(e) => setSeoDescription(e.target.value)}
                          />
                        </AccordionItemPanel>
                      </AccordionItem>

                      {/* FAQ Schema */}
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>FAQ Schema</AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <div className="form-group">
                            <div className="form-control-wrap mb-2">
                              <textarea
                                value={faqSchema}
                                name="faqSchema"
                                id="faqSchema"
                                className="form-control"
                                disabled
                                rows={2}
                                placeholder="text..."
                                onChange={(e) => {
                                  setFaqSchema(e.target.value);
                                }}
                              />
                              <div className="form-control-note">
                                <small>
                                  <span className="text-danger">*</span> This is auto-generated based on the FAQs
                                </small>
                              </div>
                            </div>
                          </div>
                        </AccordionItemPanel>
                      </AccordionItem>
                    </Accordion>
                  </Col>

                  <Col size="12">
                    <Button color="primary" type="submit">
                      <Icon className="plus"></Icon>
                      <span>{view.edit ? "Save" : "Save"}</span>
                    </Button>
                  </Col>
                </Row>
              </form>
            </div>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={view.details}
        toggle={() => {
          onFormCancel();
        }}
        className="modal-dialog-centered"
        size="lg"
      >
        <ModalBody>
          <a href="#cancel" className="close">
            <Icon
              name="cross-sm"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
            ></Icon>
          </a>
          <div className="p-2">
            <div className="card-inner">
              <Block>
                <BlockHead>
                  <BlockBetween>
                    <BlockHeadContent>
                      <BlockTitle tag="h3">Province Information</BlockTitle>
                    </BlockHeadContent>
                    <BlockHeadContent>
                      <Button
                        color="primary"
                        outline
                        onClick={(ev) => {
                          ev.preventDefault();
                          toggle("edit");
                        }}
                      >
                        <Icon name="edit"></Icon>
                        <span>Edit</span>
                      </Button>
                    </BlockHeadContent>
                  </BlockBetween>
                </BlockHead>
                {bannerTitle ? (
                  <p
                    className="profile-ud-value"
                    style={{
                      fontSize: "18px",
                      fontWeight: "600",
                      textAlign: "center",
                    }}
                  >
                    {parse(bannerTitle || "")}
                  </p>
                ) : null}
                {bannerImg ? (
                  <img
                    src={bannerImg ? `${process.env.REACT_APP_IMGURL}${bannerImg}` : PlaceholderImg}
                    alt="banner"
                    style={{ width: "100%", height: "350px", objectFit: "cover", marginBottom: "10px" }}
                  />
                ) : null}
                <div className="profile-ud-list">
                  <div className="profile-ud-item">
                    <div className="profile-ud wider">
                      <span className="profile-ud-label">Name</span>
                      <span className="profile-ud-value">{name}</span>
                    </div>
                  </div>
                  <div className="profile-ud-item">
                    <div className="profile-ud wider">
                      <span className="profile-ud-label">Slug</span>
                      <span className="profile-ud-value">{slug}</span>
                    </div>
                  </div>
                  <div className="profile-ud-item">
                    <div className="profile-ud wider">
                      <span className="profile-ud-label">Short Symbol</span>
                      <span className="profile-ud-value">{shortSymbol}</span>
                    </div>
                  </div>
                  <div className="profile-ud-item">
                    <div className="profile-ud wider">
                      <span className="profile-ud-label">Country</span>
                      <span className="profile-ud-value">{country?.label}</span>
                    </div>
                  </div>
                  {associateCost ? (
                    <div className="profile-ud-item">
                      <div className="profile-ud wider">
                        <span className="profile-ud-label">Associate Cost</span>
                        <span className="profile-ud-value">{associateCost}</span>
                      </div>
                    </div>
                  ) : null}
                </div>
              </Block>

              <hr style={{ width: "100%", height: "1px", background: "#a0a0a0", color: "#a0a0a0" }} />

              <Block>
                <BlockHead className="nk-block-head-line">
                  <BlockTitle tag="h6" className="overline-title text-base">
                    Top Cities
                  </BlockTitle>
                </BlockHead>
                {topCities?.length ? (
                  <div className={styles.topLists}>
                    {topCities?.map((li, i) => (
                      <div key={i} className={styles.topList}>
                        <div>{li.label}</div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="profile-ud-value">No Top Cities Found</p>
                )}
              </Block>

              <hr style={{ width: "100%", height: "1px", background: "#a0a0a0", color: "#a0a0a0" }} />

              <Block>
                <BlockHead className="nk-block-head-line">
                  <BlockTitle tag="h6" className="overline-title text-base">
                    Details
                  </BlockTitle>
                </BlockHead>

                {detailsTitle ? (
                  <p
                    className="profile-ud-value"
                    style={{
                      fontSize: "18px",
                      fontWeight: "600",
                      textAlign: "center",
                    }}
                  >
                    {parse(detailsTitle || "")}
                  </p>
                ) : null}

                {detailsContent ? (
                  <p className="profile-ud-value">{parse(detailsContent || "")}</p>
                ) : (
                  <p className="profile-ud-value">No Details</p>
                )}
              </Block>

              <hr style={{ width: "100%", height: "1px", background: "#a0a0a0", color: "#a0a0a0" }} />

              <Block>
                <BlockHead className="nk-block-head-line">
                  <BlockTitle tag="h6" className="overline-title text-base">
                    Accordion
                  </BlockTitle>
                </BlockHead>

                {faqTitle ? (
                  <p
                    className="profile-ud-value"
                    style={{
                      fontSize: "18px",
                      fontWeight: "600",
                      textAlign: "center",
                    }}
                  >
                    {parse(faqTitle || "")}
                  </p>
                ) : null}

                {faq?.length ? (
                  <Accordion className={styles.a} preExpanded={[1]}>
                    {faq?.map((li, i) => {
                      return (
                        <AccordionItem key={i} uuid={i + 1}>
                          <AccordionItemHeading>
                            <AccordionItemButton>{parse(li?.question || "")}</AccordionItemButton>
                          </AccordionItemHeading>
                          <AccordionItemPanel>{parse(li?.answer || "")}</AccordionItemPanel>
                        </AccordionItem>
                      );
                    })}
                  </Accordion>
                ) : (
                  <p className="profile-ud-value">No Accordion Data</p>
                )}
              </Block>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default Province;
